import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { StampList } from 'shell/models/timber';
import { memo } from 'react';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface TimberSelectProps {
  value?: string;
  onChange: (item: string) => void;
  certificate: string;
  error?: boolean;
  actType?: string;
}

const TimberSelectComponent = ({
  value,
  onChange,
  certificate,
  error,
  actType,
}: TimberSelectProps): React.ReactElement => {
  const [listaTimbri] = useHttpFetch<HttpResponseList<StampList>, Array<ItemVM>>(
    `${__CIVIL_STATUS_API_URL__}/testo-stampa-certificazione/lista-timbri-stampa-certificazione/${certificate}-TIMBROFISSO-${actType}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response: AxiosResponse<HttpResponseList<StampList>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.codiceTesto || '',
          value: item.testoStampa || '',
        }));
      },
    }
  );

  const stampsList = (listaTimbri.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`id-select-timber`}>
        Timbri
      </InputLabel>
      <PmiSelect
        labelId={`label-select-timber`}
        id={`id-select-timber`}
        name={`id-select-timber`}
        value={value}
        label={'Timbri'}
        onChange={(event) => onChange(event?.target.value)}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {stampsList.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TimberSelectComponent.displayName = 'Timber Select';

const TimberSelect = memo(TimberSelectComponent);

export default TimberSelect;
